import iconCR from '../assets/images/icon-country-results.svg';
// import iconGR from '../assets/images/icon-global-results.svg';

export const routes = [
  // { value: 'global', label: 'Global Results', icon: iconGR },
  { value: 'country', label: 'Country Results', icon: iconCR },
];

export default routes;
